import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Check if environment variables are set
export const isSupabaseConfigured = !!(supabaseUrl && supabaseAnonKey);

// Create client - will use placeholder values if env vars are missing
// This prevents the app from crashing, but Supabase operations will fail
export const supabase = createClient(
  supabaseUrl || 'https://placeholder.supabase.co',
  supabaseAnonKey || 'placeholder-key'
);

